import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const confirmAdminSensorOrder = async (orderId) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/confirm`,
    body: {},
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
